module.exports = __webpack_public_path__ + "7b972f53d2bc6be3fc9d8377ab554cf3.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/IN.svg
// module id = 8J+0
// module chunks = 0